import { CloseCircleOutlined } from "@/icons"
import { NotificationTemplate } from "./NotificationTemplate"

import styles from "./NotificationTemplate.module.scss"

import type { NotificationProps } from "./open-pr.types"

export const ErrorNotification = (props: NotificationProps) => (
  <NotificationTemplate
    icon={<CloseCircleOutlined className={styles.iconError} />}
    buttonText={props.actions.t("notifications.prTask.failedOkText")}
    buttonProps={{ type: "primary", onClick: props.actions.closeNotification }}
    text={props.getText("notifications.prTask.failed", props)}
  />
)
